module.exports = __webpack_public_path__ + "img/about_header.11aa4781.jpg";